import { useEffect } from 'react';

/**
 * Scrolls to the first highlighted sub-section once data is ready.
 *
 * Sub-sections that live inside a data-gated render block don't exist in the
 * DOM when useSettingsSectionHighlight fires on mount. Call this hook after
 * data loads to retry the scroll. The setTimeout defers past the current paint
 * so the command-palette modal is fully removed before scrollIntoView runs.
 */
export function useScrollToHighlightedSection(
  sectionHighlight: Record<string, boolean>,
  isDataReady: boolean,
): void {
  const highlightedKey =
    Object.entries(sectionHighlight).find(
      ([, highlighted]) => highlighted,
    )?.[0] ?? null;

  useEffect(() => {
    if (!isDataReady || !highlightedKey) {
      return;
    }
    const timer = setTimeout(() => {
      document
        .getElementById(highlightedKey)
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 0);
    return () => clearTimeout(timer);
  }, [isDataReady, highlightedKey]);
}
